export default {
    environment: 'development',
    appHostname: 'practitioner.luminalearning.local',
    ssoV1Hostname: 'sso.luminalearning.local',
    ssoV2Hostname: 'sso.v2.luminalearning.local',
    financeHostname: 'finance.luminalearning.local',
    graphqlGatewayHostname: 'graphql.api.luminalearning.local',
    luminaOnlineHostname: 'www.luminalearning.local',
    luminaOpenBadgesClientHostname: 'localhost:44385',
    luminaGetQualifiedUrlHostname: 'luminalearning.com/become-a-practitioner/',
    teamsHostname: 'team.luminalearning.local',
    AtsHostname: 'ats.luminalearning.local',
    eLearningHostname: 'e-learning.luminalearning.local',
    keycloakServerUrl: 'auth.luminalearning.local',
    participantProjectPaginationLimit: 10,
    projectAndSearchPaginationLimit: 20,
    forceHttps: false,
};
